import React, { useState } from 'react';
import { FadeIn } from './ui';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQItem = ({
  q,
  a
}: {
  q: string;
  a: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/5 last:border-0" data-id="element-27">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-28">
        <span className="font-serif text-xl text-parchment group-hover:text-amber transition-colors pr-4" data-id="element-29">
          {q}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="text-parchment-dark shrink-0" data-id="element-30">
          <ChevronDown size={20} strokeWidth={1.5} data-id="element-31" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-32">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-33">
            <p className="pb-6 text-parchment-muted font-light leading-relaxed" data-id="element-34">
              {a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: 'Will I have to read this every night?',
    a: 'No. Once you learn the "shuffle," it becomes a mental tool you can use anywhere, even without the book.'
  }, {
    q: 'Does this work if I’ve had caffeine late in the day?',
    a: 'It helps, but it’s not a miracle cure for caffeine. It’s designed to stop psychological loops, not chemical ones.'
  }, {
    q: 'What if I have ADHD?',
    a: 'This is actually more effective for "racing minds" because it gives the brain a simple, low-stakes task to focus on.'
  }, {
    q: 'Is this a long book?',
    a: 'No. It’s a tactical script designed to be read and implemented immediately.'
  }];
  return <section className="py-16 px-6" data-id="element-35">
      <div className="max-w-2xl mx-auto" data-id="element-36">
        <FadeIn data-id="element-37">
          <h2 className="text-3xl text-center mb-10" data-id="element-38">Common Questions</h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-39">
          <div className="bg-surface/30 rounded-2xl px-6 md:px-8 border border-white/5" data-id="element-40">
            {faqs.map((faq, index) => <FAQItem key={index} q={faq.q} a={faq.a} data-id="element-41" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};